import type { ModalOptions } from "../state";
import { esc } from "./stars";

export function renderConfirmModal(options: ModalOptions): string {
  return `
    <div class="lcars-modal-overlay" id="modal-overlay">
      <div class="lcars-modal">
        <div class="lcars-modal__header">${esc(options.title)}</div>
        <div class="lcars-modal__body">${esc(options.message)}</div>
        <div class="lcars-modal__actions">
          <button class="lcars-btn lcars-btn--${options.confirmColor}" id="modal-confirm-btn">
            ${esc(options.confirmLabel)}
          </button>
          <button class="lcars-btn lcars-btn--blue" id="modal-cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  `;
}
